import { render, staticRenderFns } from "./MerchantPanel.vue?vue&type=template&id=df640ce2&scoped=true"
import script from "./MerchantPanel.vue?vue&type=script&lang=js"
export * from "./MerchantPanel.vue?vue&type=script&lang=js"
import style0 from "./MerchantPanel.vue?vue&type=style&index=0&id=df640ce2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df640ce2",
  null
  
)

export default component.exports